import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class FrequencyOfDeposits extends KYCQuestion
{
	state = {
		fields: {
			radio_aml_deposit: {
				options: [
					{
						name: "radio_aml_deposit",
						label: "Mindre än 1 gång/månad",
						value: "<1/m",
						checked: false
					},
					{
						name: "radio_aml_deposit",
						label: "1 - 5 gånger/månad",
						value: "1-5/m",
						checked: false
					},
					{
						name: "radio_aml_deposit",
						label: "Mer än 5 gånger/månad",
						value: ">5/m ",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "radio_aml_deposit";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="radio"
					name="radio_aml_deposit"
					description="Hur ofta tänker du göra insättningar?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.radio_aml_deposit.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/FrequencyOfDeposits.js